import EventEmitter from 'eventemitter3';
import lodashMerge from 'lodash/merge';

import {assertDependencies, inherits} from '../lib/util';

const MANIFEST = require('./manifest');

const DEFAULT_OPTIONS = {
	// Initial enabled state
	enabled: true,

	// How long should user be idle before we consider them away (in ms)
	idle_threshold: 5 * 1000,
};

export const EMIT = {
	idle: 'idle'
};

function IdleDetector(options = DEFAULT_OPTIONS, deps = MANIFEST.dependencies) {
	const thisIdleDetector = this;

	EventEmitter.apply(this);

	options = lodashMerge({}, DEFAULT_OPTIONS, options);
	assertDependencies(MANIFEST.name, MANIFEST.dependencies, deps);

	const log = deps.logger.child(MANIFEST.name);

	let _enabled = options.enabled,
		//_overlay = null,
		_timeout = null,
		_idle = false;

	Object.assign(thisIdleDetector, /** @lends IdleDetector.prototype */ {
		init,
		ping,
		isEnabled: () => _enabled,
		isIdle: () => _enabled ? _idle : null,
		enable,
		disable,
	});

	function init() {
		deps.jQuery(deps.document).on('mousemove keypress', resetTimer);

		//TODO: Doesn't work
		/*if (browser && (browser.name !== 'ie' || (browser.version && parseInt(browser.version, 10) >= 11))) {
			// On new browsers, add an overlay to help with iFrame events

			deps.jQuery(deps.document.head).append(`
				<style>
					#__idle_detector_overlay__ {
						position: fixed;
						left: 0;
						top: 0;
						right: 0;
						bottom: 0;
						z-index: 16777271;
						pointer-events: none;
					}
					#__idle_detector_overlay__:hover, #__idle_detector_overlay__:active {
						pointer-events: all;
					}
				</style>
			`);
			_overlay = deps.jQuery('<div id="__idle_detector_overlay__"></div>');
			deps.jQuery(deps.document.body).append(_overlay);
			_overlay.on('mousemove keypress', resetTimer);
		}*/

		resetTimer();
		log.verbose('Initialized');
	}

	/**
	 * Reset the timer, as if user moved a mouse
	 */
	function ping() {
		log.verbose('Pinged from outside');
		resetTimer();
	}

	function enable() {
		log.info('Enabled');
		_enabled = true;
		resetTimer();
	}

	function disable() {
		log.info('Disabled');
		_enabled = false;
		resetTimer();
	}

	function resetTimer() {
		if (_idle && _enabled) {
			log.info('User is marked as active');
			_idle = false;
			thisIdleDetector.emit(EMIT.idle, false);
		}
		clearTimeout(_timeout);
		if (_enabled) {
			_timeout = setTimeout(onTimeout, options.idle_threshold);
		}
	}

	function onTimeout() {
		if (_idle === false && _enabled) {
			log.info('User is marked as idle');
			_idle = true;
			thisIdleDetector.emit(EMIT.idle, true);
		}
	}
}
inherits(IdleDetector, EventEmitter);

export default IdleDetector;
